var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.hasCurrent ? 'chat-window' : 'chat-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],tag:"component",staticClass:"chat-container"})
}
var staticRenderFns = []

export { render, staticRenderFns }